import { Button, LoadingOverlay, Modal, Text } from "@marketplace/ui";
import { useAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { crmProductModalAtom } from "../../atoms/integration-product-modal-atom";
import { useCrmProductForm } from "../../hooks/forms/use-crm-product-form";
import { CrmProductAttributes } from "./crm-product-attributes";
import { CrmProductHierarchy } from "./crm-product-hierarchy";
import { CrmProductMedia } from "./crm-product-media";
export const CrmProductModal = () => {
  const { t } = useTranslation("product", {
    keyPrefix: "integrationProductListPage.crmModal"
  });

  const [{ visible: opened, data: modalData }] = useAtom(crmProductModalAtom);
  const resetCrmModal = useResetAtom(crmProductModalAtom);

  const productId = modalData?.lampu_product_id ?? "";
  const productName = modalData?.product_name ?? "";
  const onClose = resetCrmModal;

  const {
    formMethods,
    onSubmit,
    isPending,
    isLoadingDetail,
    handleMediaFileChange,
    isMediaPresignedLoading
  } = useCrmProductForm({
    productId,
    productName,
    onSuccess: onClose
  });
  const { reset } = formMethods;

  // Reset form when modal closes
  useEffect(() => {
    if (!opened) {
      reset();
    }
  }, [opened, reset]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text type="heading" weight="semibold">
          {t("title")}
        </Text>
      }
      size={610}
      classNames={{
        header: "!p-6",
        body: "!p-6 !pt-0"
      }}
    >
      <LoadingOverlay visible={isLoadingDetail} />
      <FormProvider {...formMethods}>
        <form onSubmit={onSubmit}>
          <div className="flex flex-col gap-4">
            <CrmProductHierarchy opened={opened} isPending={isPending} />
            <CrmProductAttributes isPending={isPending} />
            <CrmProductMedia
              isPending={isPending}
              handleMediaFileChange={handleMediaFileChange}
              isMediaPresignedLoading={isMediaPresignedLoading}
            />

            {/* Action Buttons */}
            <div className="flex justify-end gap-x-[14px]">
              <Button
                variant="secondary"
                onClick={onClose}
                disabled={isPending}
                className="w-[128px]"
              >
                {t("buttons.discard")}
              </Button>
              <Button
                variant="primary"
                type="submit"
                loading={isPending}
                className="w-[128px]"
              >
                {t("buttons.submit")}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
